var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirplane = function SvgAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11 9.744-6 4.285v1.735l6-3v6.01l-2 .668v.87l3-.9 3 .9v-.87l-2-.667v-6.011l6 3v-1.735l-6-4.285V5a1 1 0 1 0-2 0v4.744Zm8.553 8.532A1 1 0 0 0 21 17.382v-3.867a1 1 0 0 0-.419-.814L15 8.714V5a3 3 0 1 0-6 0v3.714l-5.581 3.987a1 1 0 0 0-.419.814v3.867a1 1 0 0 0 1.447.894L9 16v1.333l-1.316.44A1 1 0 0 0 7 18.72v2.935a1 1 0 0 0 1.287.958L12 21.5l3.713 1.114A1 1 0 0 0 17 21.656v-2.935a1 1 0 0 0-.684-.949L15 17.333V16l4.553 2.276Z",
    clipRule: "evenodd"
  })));
};
export default SvgAirplane;